export const FacebookIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
            <path d="M17.1667 8.33333C17.1667 3.73333 13.4333 0 8.83333 0C4.23333 0 0.5 3.73333 0.5 8.33333C0.5 12.3667 3.36667 15.725 7.16667 16.5V10.8333H5.5V8.33333H7.16667V6.25C7.16667 4.64167 8.475 3.33333 10.0833 3.33333H12.1667V5.83333H10.5C10.0417 5.83333 9.66667 6.20833 9.66667 6.66667V8.33333H12.1667V10.8333H9.66667V16.625C13.875 16.2083 17.1667 12.6583 17.1667 8.33333Z" fill="#222222"/>
        </svg>
    )
}